import React from "react";
import { Link } from "react-router-dom";

import "./Intro.scss";

import { landingUrls, INTRO_VIDEO_URL, ABOUT_PROJECT_URL } from "../utils";
import { VimeoContainer } from "../components";

const ProjectTitle = ({ className = "" }) => {
  return (
    <div className={`fade-in flex flex-column z2 px3 ${className}`}>
      <TitleAndSubtitle className="z2" />
      <Collaborators className="z2 mt2" />
    </div>
  );
};

const TitleAndSubtitle = ({ className = "" }) => {
  return (
    <div className={`py1 block-font h0 ${className}`}>
      <div className="uppercase bold">Digital Violence</div>
      <div>
        How the <span className="bold inverted px1">NSO Group</span> Enables
        State Terror
      </div>
    </div>
  );
};

const Collaborators = ({ className = "" }) => (
  <div className={`block-font h4 ${className}`}>
    <div className="flex flex-row flex-wrap">
      <div className="flex flex-column mr3">
        <div>Project by</div>
        <div
          className="flex flex-row flex-wrap items-center mt1"
          style={{ height: `60px` }}
        >
          <a href="https://forensic-architecture.org" target="__blank">
            <div
              className=" pointer"
              style={{
                height: `35px`,
                width: `210px`,
                // width: `343px`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top center",
                backgroundImage: `url(assets/img/fa-wide.png)`,
              }}
            />
          </a>
        </div>
      </div>
      <div className="flex flex-column">
        <div>Supported by</div>
        <div
          className="flex flex-row items-center justify-start mt1"
          style={{ height: `60px` }}
        >
          <a href="https://amnesty.org/" target="__blank">
            <div
              className="rounded pointer mr2"
              style={{
                height: `51px`,
                width: `120px`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top center",
                backgroundImage: `url(assets/img/amnesty-wide.png)`,
              }}
            />
          </a>
          <a href="https://citizenlab.ca" target="__blank">
            <div
              className="rounded mr2 pointer"
              style={{
                height: `51px`,
                width: `112px`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top center",
                backgroundImage: `url(assets/img/citizenlab-wide.png)`,
              }}
            />
          </a>
        </div>
      </div>
    </div>
  </div>
);

const Navigation = () => {
  return (
    <div className="mxn4 intro__navigation flex flex-column justify-around block-font relative">
      {Object.values(landingUrls).map((u, idx) => (
        <div
          key={`landing-url-${idx}`}
          className="intro__navigation-item col-12 flex flex-auto flex-grow "
        >
          <Link
            key={`landing-url-${u.path}`}
            to={u.path}
            className="full-width"
          >
            <div
              className="button__container p3 h1 border-x-hidden"
              style={{ height: `100%` }}
            >
              <div className="flex flex-column">
                <div>{u.text}</div>
                {u.subtitle && (
                  <div className="color-gray h2">{u.subtitle}</div>
                )}
              </div>
            </div>
          </Link>
        </div>
      ))}
      <div className="intro__navigation-item col-12 flex flex-auto flex-grow ">
        <a
          className="col-12 button__container p3 h1 border-x-hidden"
          href={ABOUT_PROJECT_URL}
          target="__blank"
        >
          About this Project
        </a>
      </div>
    </div>
  );
};

export default function Intro() {
  return (
    <>
      <ProjectTitle className="mt4 sm-hide md-hide lg-hide" />
      <div className="intro block-font py-navbar">
        <VimeoContainer controls url={INTRO_VIDEO_URL} className="mb4">
          <ProjectTitle
            className=" xs-hide absolute
top-navbar"
          />
        </VimeoContainer>

        <div className="px4">
          <div className="col-12 flex flex-row justify-around h0 bold mb2">
            Sections
          </div>
          {/* <InView onChange={(inView) => setVideoPlaying(inView)}></InView> */}
          <Navigation />
        </div>
      </div>
    </>
  );
}
